import type { SupportKind } from '@/lib/support/triage';

export const OPEN_SUPPORT_EVENT = 'owlscran:support:open';

export type OpenSupportDetail = {
  /** Where the visitor asked for help, e.g. 'navbar' or 'sync_failed'. Used as a ticket tag. */
  source: string;
  /** Skip the picker when the entry point already knows what this is. */
  kind?: SupportKind;
};

/** Opens the Help panel from anywhere, including toasts rendered outside layouts. */
export function openSupport(detail: OpenSupportDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<OpenSupportDetail>(OPEN_SUPPORT_EVENT, { detail }));
}
